// const baseUrl = 'https://content.dcg.longdivision.digital';
const baseUrl = '/.netlify/functions';

const settings = {
  baseUrl,
  contentUrl: `${baseUrl}/content`,
  projectListingsUrl: `${baseUrl}/project-listing?pageSize=0`,
  projectsUrl: `${baseUrl}/project-tag?tag={tag}&pageSize=0`,
  projectUrl: `${baseUrl}/project?slug={slug}`,
  pageUrl: `${baseUrl}/page?slug={slug}`,
  breakpoints: {
    xs: 0,
    sm: 576,
    md: 768,
    lg: 992,
    xl: 1200,
  },
};

export default settings;



// WEBPACK FOOTER //
// ./src/settings.js